import { Route } from 'react-router-dom';
import IconCKK from '../assets/media/icons_new/find.svg';
import IconProviders from '../assets/media/icons_new/goods.svg';
import IconMarketplaces from '../assets/media/icons_new/marketplaces.svg';
import IconOrders from '../assets/media/icons_new/orders.svg';
import IconCreateOrders from '../assets/media/icons_new/orders_create.svg';
import IconFbo from '../assets/media/icons_new/fbo.svg';
import IconFbo2 from '../assets/media/icons_new/fbo2.svg';
import IconFbo3 from '../assets/media/icons_new/fbo3.svg';
import IconRealization from '../assets/media/icons_new/report.svg';
import IconSettings from '../assets/media/icons_new/settings.svg';
import IconStatistic from '../assets/media/icons_new/statistic.svg';
import IconWarehouse from '../assets/media/icons_new/warehouse.svg';
import ControlQualityPages from '../pages/ControlQuality/Pages';
import MarketPages from '../pages/Markets/Pages';
import OrderPages from '../pages/Orders/Pages';
import ProviderPages from '../pages/Providers/Pages';
import ReportsPages from '../pages/Reports/Pages';
import SettingsAdminPages from '../pages/Settings/Pages';
import ShipmentPages from '../pages/Shipments/Pages';
import StatisticPages from '../pages/Statistic/Pages';
import UserPages from '../pages/User/Pages';
import WarehousePages from '../pages/Warehouse/Pages';
import routerMaker from '../utils/routerMaker';

const routesShipment = [
  { name: 'Оформление заказов', path: 'orders', element: <ShipmentPages.Orders /> },
  { name: 'Заказ', path: 'orders/:id', element: <ShipmentPages.Order />, isNotHeaderPage: true },
  { name: 'Отгрузки', path: 'shipments', element: <ShipmentPages.Shipments /> },
  // { name: 'Поставки FBO', path: 'supplies', element: <ShipmentPages.Supplies /> },
  // { name: 'Поставка FBO', path: 'supplies/:id', element: <ShipmentPages.Supply />, isNotHeaderPage: true },
  // { name: 'Склад ВБ', path: 'wb_storage', element: <ShipmentPages.WbStoragePage /> },
  { name: 'Упаковка', path: 'packaging', element: <ShipmentPages.Packaging /> },
  { name: 'Отгрузка', path: 'shipments/:id', element: <ShipmentPages.Shipment />, isNotHeaderPage: true },
  { name: 'Отправление', path: 'posting/:number', element: <ShipmentPages.Posting />, isNotHeaderPage: true },
  { name: 'Экспрессы', path: 'express', element: <ShipmentPages.Shipment isExpress={true} /> },
  { name: 'Все заказы', path: 'postings', element: <ShipmentPages.AllPostings /> },
  { name: 'Докупы', path: 'dokup', element: <ShipmentPages.DokupPostings /> },
  { name: 'Расхождения', path: 'discrepancies', element: <ShipmentPages.DiscrepanciesPostings /> },
  { name: 'Сортировка', path: 'sorting', element: <ShipmentPages.Sorting /> },
]


const routesFbo = [
  { name: 'Поставки FBO', path: 'supplies', element: <ShipmentPages.Supplies /> },
  { name: 'Все товары', path: 'all_products', element: <ShipmentPages.Supply /> },
  { name: 'Поставка FBO', path: 'supplies/:id', element: <ShipmentPages.Supply />, isNotHeaderPage: true },
  { name: 'Склад ВБ', path: 'wb_storage', element: <ShipmentPages.WbStoragePage /> },
  { name: 'Остатки FBS Wb', path: 'fbswb', element: <MarketPages.Wb /> },
  { name: 'Остатки FBS Ozon', path: 'fbsozon', element: <MarketPages.Ozon /> },
  { name: 'Остатки FBS Yandex', path: 'fbsyandex', element: <MarketPages.Yandex /> },
]

const routesMarkets = [
  { name: 'Ozon', path: 'ozon', element: <MarketPages.Ozon /> },
  { name: 'Wildberries', path: 'wb', element: <MarketPages.Wb /> },
  { name: 'ЯндексМаркет', path: 'yandex', element: <MarketPages.Yandex /> },
  { name: 'Мегамаркет', path: 'mm', element: <MarketPages.MegaMarket /> },
  { name: 'Купер', path: 'kuper', element: <MarketPages.Kuper /> },
  { name: 'Авито', path: 'avito', element: <MarketPages.Avito /> },
  { name: 'B-White', path: 'bwhite', element: <MarketPages.Bwhite /> },
  { name: 'Статусы обновления', path: 'statuses', element: <MarketPages.MarketsUpdateStatus /> },
];

const routesOrders = [
  { name: 'Ozon заказы', path: 'ozon', element: <OrderPages.Ozon /> },
  {
    name: 'Wildberries заказы',
    path: 'wb',
    element: <OrderPages.Wb.Parent />,
    nestedRouter: (
      <>
        <Route index element={<OrderPages.Wb.Orders />} />
        <Route path="supplies" element={<OrderPages.Wb.Supplies />} />
      </>
    ),
  },
  { name: 'Поставки', path: 'wb/supplies/:shop/:id', element: <OrderPages.Wb.Supplie />, isNotHeaderPage: true },
  { name: 'ЯндексМаркет заказы', path: 'yandex', element: <OrderPages.Yandex /> },
  { name: 'Wildberries Express', path: 'wbexpress', element: <OrderPages.Wb.Express /> },
];

const routesWarehouse = [
  { name: 'Товары', path: 'products', element: <WarehousePages.WarehouseProducts /> },
  { name: 'Товар', path: 'products/:id', element: <WarehousePages.WarehouseProduct />, isNotHeaderPage: true },

  { name: 'Резервы', path: 'reserves', element: <WarehousePages.Reserves /> },
  { name: 'Резерв', path: 'reserves/:id', element: <WarehousePages.Reserve />, isNotHeaderPage: true },

  { name: 'Возвраты', path: 'returns_by_days', element: <WarehousePages.Returns /> },
  { name: 'Возврат', path: 'returns_by_days/:id', element: <WarehousePages.Return />, isNotHeaderPage: true },

  { name: 'Внесения', path: 'entries', element: <WarehousePages.Entries /> },
  { name: 'Внесение', path: 'entries/:id', element: <WarehousePages.Entry />, isNotHeaderPage: true },

  { name: 'Занесение товаров', path: 'entry_goods', element: <WarehousePages.Addition /> },
  { name: 'Занесение возвратов', path: 'returns', element: <WarehousePages.ReturnsEntry /> },
  { name: 'Занесение с отгрузок', path: 'overage', element: <WarehousePages.Overages /> },
];

const routesProvider = [
  {
    name: 'Стоки',
    path: 'stocks',
    nestedRouter: (
      <>
        <Route index element={<ProviderPages.Stocks />} />,
        {/* <Route path='nothing' element={<Content><div>HELLOO</div></Content>} />, */}
      </>
    ),
  },
  { name: 'Комус', path: 'komus', element: <ProviderPages.Komus /> },
  { name: 'Самсон', path: 'samson', element: <ProviderPages.Samson /> },
  { name: 'Рельеф-центр', path: 'relef', element: <ProviderPages.Relef /> },
  { name: 'Гала-центр', path: 'gala', element: <ProviderPages.Gala /> },
  { name: 'Сима-ленд', path: 'sima_land', element: <ProviderPages.SimaLand /> },
  { name: 'Обновление остатков', path: 'stocks_update', element: <ProviderPages.StocksUpdate /> },
  { name: 'Заливка контента', path: 'content', element: <ProviderPages.ContentWork /> },
  { name: 'Стоп бренды', path: 'stopbrands', element: <ProviderPages.StopBrands /> },
  { name: 'Товар', path: 'product/:sku', element: <ProviderPages.Product />, isNotHeaderPage: true },
];

const routesControl = [
  { name: 'Отгрузки', path: 'shipment', element: <ControlQualityPages.Shipment /> },
  { name: 'ЗНК', path: 'camera', element: <ControlQualityPages.Camera /> },
  { name: 'Отзывы', path: 'reviews', element: <ControlQualityPages.Reviews /> },
  { name: 'Расхождения', path: 'discrepancies', element: <ControlQualityPages.Discrepancies /> },
  { name: 'Склад', path: 'warehouse', element: <ControlQualityPages.Warehouse /> },
  { name: 'Резервы', path: 'reserves', element: <ControlQualityPages.Reserve /> },
  { name: 'Штрафы', path: 'penalties', element: <ControlQualityPages.Penalty /> },
];

const routesSettingsAdmin = [
  { name: 'Настройки', path: 'common', element: <SettingsAdminPages.Common /> },
  { name: 'Сотрудники склада', path: 'workers', element: <SettingsAdminPages.Users /> },
  { name: 'Поставщики', path: 'providers', element: <SettingsAdminPages.Providers /> },
  { name: 'Архив сотрудников', path: 'archive', element: <SettingsAdminPages.UsersArchive /> },
];

const routesUser = [
  { name: 'Профиль', path: 'profile', element: <UserPages.Profile />, isNotHeaderPage: true },
  { name: 'Сотрудник склада', path: 'profile/:userId', element: <UserPages.Profile />, isNotHeaderPage: true },
  { name: 'Период', path: 'profile/:userId/:periodId', element: <UserPages.PeriodFinances />, isNotHeaderPage: true },
];

const routesStatistic = [
  { name: 'Отгрузки', path: 'shipments', element: <StatisticPages.ShipmentStatistic /> },
  { name: 'Отгрузки FBO', path: 'shipmentsfbs', element: <StatisticPages.ShipmentStatisticFbo /> },
  { name: 'Отгрузка', path: 'shipments/:id', element: <StatisticPages.Shipment />, isNotHeaderPage: true },


];

const routesReport = [
  { name: 'Остатки 1с', path: 'stocks', element: <ReportsPages.IpStocks41 /> },
  { name: 'Реализации', path: 'realizations', element: <ReportsPages.Realizations /> },
  { name: 'Реализация', path: 'realizations/:id', element: <ReportsPages.Realization />, isNotHeaderPage: true },
  { name: 'Отчеты маркетплейсов', path: 'reports', element: <ReportsPages.MarketReports /> },
  { name: 'Отчёт', path: 'reports/:id', element: <ReportsPages.MarketReport />, isNotHeaderPage: true },
  { name: 'Отчеты по возвратам', path: 'returns', element: <ReportsPages.ReturnsReportsPage /> },
  {
    name: 'Отчет по возвратам',
    path: 'returns/:id',
    element: <ReportsPages.ReturnsReportPage />,
    isNotHeaderPage: true,
  },
  { name: 'Все операции', path: 'operations', element: <ReportsPages.MarketReportItemsAll /> },
  { name: 'Номенклатура', path: 'nomenclature', element: <ReportsPages.Nomenclature /> },
  { name: 'Проверка бухгалтерии', path: 'control', element: <ReportsPages.ControlQuality /> },
];

const NAVIGATION = {
  shipment: {
    imgSideBar: { src: IconCreateOrders, width: '30px', height: '40px' },
    rootUrl: 'shipment',
    text: 'Отгрузка',
    routes: routesShipment,
    defaultPage: 'shipments',
  },
  fbo: {
    imgSideBar: { src: IconFbo3, color: 'white', width: '30px', height: '40px' },
    rootUrl: 'fbo',
    text: 'Поставки',
    routes: routesFbo,
    defaultPage: 'supplies',
    // isNotSideBarPage: true,
  },
  market: {
    imgSideBar: { src: IconMarketplaces, width: '30px', height: '40px' },
    rootUrl: 'market',
    text: 'Маркетплейсы ',
    routes: routesMarkets,
    defaultPage: 'ozon',
  },
  orders: {
    imgSideBar: { src: IconOrders, width: '30px', height: '40px' },
    rootUrl: 'orders',
    text: 'Новые заказы',
    routes: routesOrders,
    defaultPage: 'ozon',
  },
  provider: {
    imgSideBar: { src: IconProviders, width: '30px', height: '40px' },
    rootUrl: 'provider',
    text: 'Поставщики',
    routes: routesProvider,
    defaultPage: 'stocks',
  },
  warehouse: {
    imgSideBar: { src: IconWarehouse, width: '30px', height: '30px' },
    rootUrl: 'warehouse',
    text: 'Склад',
    routes: routesWarehouse,
    defaultPage: 'products',
  },
  report: {
    imgSideBar: { src: IconRealization, width: '27px', height: '30px' },
    rootUrl: 'report',
    text: 'Бухгалтерия',
    routes: routesReport,
    defaultPage: 'stocks',
  },
  statistic: {
    imgSideBar: { src: IconStatistic, width: '29px', height: '30px' },
    rootUrl: 'statistic',
    text: 'Статистика',
    routes: routesStatistic,
    defaultPage: 'stocks',
  },
  control: {
    imgSideBar: { src: IconCKK, width: '27px', height: '30px' },
    rootUrl: 'control',
    text: 'Проверки',
    routes: routesControl,
    defaultPage: 'shipment',
  },
  settings: {
    imgSideBar: { src: IconSettings, width: '30px', height: '40px' },
    rootUrl: 'settings',
    text: 'Настройки',
    routes: routesSettingsAdmin,
    defaultPage: 'common',
  },
  user: {
    imgSideBar: { src: IconSettings, width: '30px', height: '40px' },
    rootUrl: 'user',
    text: 'Пользователь',
    routes: routesUser,
    defaultPage: 'profile',
    isNotSideBarPage: true,
  },
};

const GlobalRouter = {
  ShipmentRouter: routerMaker({
    routes: NAVIGATION.shipment.routes,
    rootUrl: NAVIGATION.shipment.rootUrl,
    defaultPage: NAVIGATION.shipment.defaultPage,
  }),
  FboRouter: routerMaker({
    routes: NAVIGATION.fbo.routes,
    rootUrl: NAVIGATION.fbo.rootUrl,
    defaultPage: NAVIGATION.fbo.defaultPage,
  }),
  MarketRouter: routerMaker({
    routes: NAVIGATION.market.routes,
    rootUrl: NAVIGATION.market.rootUrl,
    defaultPage: NAVIGATION.market.defaultPage,
  }),
  OrdersRouter: routerMaker({
    routes: NAVIGATION.orders.routes,
    rootUrl: NAVIGATION.orders.rootUrl,
    defaultPage: NAVIGATION.orders.defaultPage,
  }),
  ProviderRouter: routerMaker({
    routes: NAVIGATION.provider.routes,
    rootUrl: NAVIGATION.provider.rootUrl,
    defaultPage: NAVIGATION.provider.defaultPage,
  }),
  WarhouseRouter: routerMaker({
    routes: NAVIGATION.warehouse.routes,
    rootUrl: NAVIGATION.warehouse.rootUrl,
    defaultPage: NAVIGATION.warehouse.defaultPage,
  }),
  ReportRouter: routerMaker({
    routes: NAVIGATION.report.routes,
    rootUrl: NAVIGATION.report.rootUrl,
    defaultPage: NAVIGATION.report.defaultPage,
  }),
  ControlRouter: routerMaker({
    routes: NAVIGATION.control.routes,
    rootUrl: NAVIGATION.control.rootUrl,
    defaultPage: NAVIGATION.control.defaultPage,
  }),
  StatisticRouter: routerMaker({
    routes: NAVIGATION.statistic.routes,
    rootUrl: NAVIGATION.statistic.rootUrl,
    defaultPage: NAVIGATION.statistic.defaultPage,
  }),
  SettingsAdminRouter: routerMaker({
    routes: NAVIGATION.settings.routes,
    rootUrl: NAVIGATION.settings.rootUrl,
    defaultPage: NAVIGATION.settings.defaultPage,
  }),
  UserRouter: routerMaker({
    routes: NAVIGATION.user.routes,
    rootUrl: NAVIGATION.user.rootUrl,
    defaultPage: NAVIGATION.user.defaultPage,
    isPublic: true,
  }),

};

export { GlobalRouter, NAVIGATION };
